
import { useMutation, useQueryClient } from '@tanstack/react-query';
import { useToast } from "@/hooks/use-toast";
import { saveState } from './save-state/saveOperations';
import { extractUserFriendlyMessage } from './save-state/errorHandlers';

export interface SaveStateParams {
  name: string;
  country: string;
  league: string;
  year: string;
  data: any[];
  id?: number;
  isUpdate?: boolean;
}

export interface SaveStateMutationResult {
  saveStateMutation: ReturnType<typeof useMutation<any, Error, SaveStateParams>>;
}

export const useSaveStateMutations = (resetForm: () => void): SaveStateMutationResult => {
  const { toast } = useToast();
  const queryClient = useQueryClient();

  const saveStateMutation = useMutation({
    mutationFn: saveState,
    onSuccess: (result, variables) => {
      console.log('State saved successfully:', result);
      toast({
        title: "Success",
        description: variables.isUpdate 
          ? "State updated successfully" 
          : "State saved successfully"
      });
      resetForm();
      // Make sure to invalidate the saved-states query to refresh the data
      queryClient.invalidateQueries({ queryKey: ['saved-states'] });
    },
    onError: (error: any) => {
      console.error('Error in saveStateMutation:', error);
      
      // Extract the most user-friendly error message
      const errorMessage = extractUserFriendlyMessage(error);
      
      toast({
        title: "Error",
        description: errorMessage,
        variant: "destructive",
      });
    }
  });

  return {
    saveStateMutation
  };
};
